import React, { Fragment } from 'react';
import { defaultTemplate } from 'core/hoc';
import { BaasicButton, BaasicCheckbox, BaasicDropdown, Loader } from 'core/components';
import _ from 'lodash';

const NeverShippedTemplate = ({
	t,
	neverShippedViewStore: {
		loading,
		voidOnChannel,
		modalParams,
		markNeverShipped,
		isBulkAction,
		selectedItem,
		selectedItems,
		neverShippedDropdownStore,
	},
}) => {
	if (loading) return <Loader />;
	return (
		<React.Fragment>
			<div className="ReactModal__header">
				<p className="spc--bottom--sml">
					{isBulkAction ? t('ORDERVIEW.CONFIRMNEVERSHIPPEDBULK') : t('ORDERVIEW.CONFIRMNEVERSHIPPED')}
				</p>
				<BaasicDropdown dropdownStore={neverShippedDropdownStore} />
				{neverShippedDropdownStore.value === 0 &&
					(_.get(selectedItem, 'isBuyShipping') == true ||
						_.findIndex(selectedItems, item => item.isBuyShipping == true) != -1) && (
						<div className="spc--bottom--sml">
							<label className="display--b">{t('VOIDLABELCONFIRMATIONVIEW.VOIDONCHANNEL')}</label>
							<Fragment>
								<BaasicCheckbox
									id={'voidOnChannel'}
									onChangeCallback={() => (voidOnChannel = !voidOnChannel)}
									checked={voidOnChannel}
									className="input--toggle input--toggle--secondary"
								/>
							</Fragment>
						</div>
					)}
			</div>
			<div className="ReactModal__footer">
				<BaasicButton className="btn btn--med btn--primary spc--bottom--sml" onClick={markNeverShipped} label="SAVE" />
				<BaasicButton
					className="btn btn--med btn--ghost spc--bottom--sml"
					onClick={() => modalParams.close()}
					label="CANCEL"
				/>
			</div>
		</React.Fragment>
	);
};

export default defaultTemplate(NeverShippedTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/order/pages/NeverShippedTemplate.jsx